import React, {useState, useEffect} from "react";
import Table from "../../../../../app/components/Table"
import Pagination from "../../../../../app/components/Pagination";

const Sent = ({setCount}) => {
    const columns = [
    { campo: 'remetente', titulo: 'Remetente' },
    { campo: 'assunto', titulo: 'Assunto' },
    { campo: 'destinatario', titulo: 'Destinatários' },
    { campo: 'templates', titulo: 'Templates' },
    { campo: 'status', titulo: 'Status' },
    { campo: 'enviado_em', titulo: 'Enviado em' },
  ];

  const [dataSents, setDataSents] = useState([
      { id: 1, remetente: 'smtp@mkt.odoscontabilidade.com.br', assunto: 'Lembrete: Apuração de impostos', destinatario: 'empresaemail@gmail.com', templates: 'Reenvio 1 - Apuração', status: 'enviado', enviado_em: '20/06/2025, 20:18:05'},
      { id: 2, remetente: 'smtp@mkt.odoscontabilidade.com.br', assunto: 'Lembrete: Apuração de impostos', destinatario: 'empresaemail@gmail.com', templates: 'Reenvio 1 - Apuração', status: 'enviado', enviado_em: '20/06/2025, 20:18:05'},
      { id: 3, remetente: 'smtp@mkt.odoscontabilidade.com.br', assunto: 'Lembrete: Apuração de impostos', destinatario: 'empresaemail@gmail.com', templates: 'Reenvio 1 - Apuração', status: 'enviado', enviado_em: '20/06/2025, 20:18:05'},
      { id: 4, remetente: 'smtp@mkt.odoscontabilidade.com.br', assunto: 'Lembrete: Apuração de impostos', destinatario: 'empresaemail@gmail.com', templates: 'Reenvio 1 - Apuração', status: 'enviado', enviado_em: '20/06/2025, 20:18:05'},
      { id: 5, remetente: 'smtp@mkt.odoscontabilidade.com.br', assunto: 'Lembrete: Apuração de impostos', destinatario: 'empresaemail@gmail.com', templates: 'Reenvio 1 - Apuração', status: 'enviado', enviado_em: '20/06/2025, 20:18:05'},
      { id: 6, remetente: 'smtp@mkt.odoscontabilidade.com.br', assunto: 'Lembrete: Apuração de impostos', destinatario: 'empresaemail@gmail.com', templates: 'Reenvio 1 - Apuração', status: 'enviado', enviado_em: '20/06/2025, 20:18:05'},
      { id: 7, remetente: 'smtp@mkt.odoscontabilidade.com.br', assunto: 'Lembrete: Apuração de impostos', destinatario: 'empresaemail@gmail.com', templates: 'Reenvio 1 - Apuração', status: 'enviado', enviado_em: '20/06/2025, 20:18:05'},
      { id: 8, remetente: 'smtp@mkt.odoscontabilidade.com.br', assunto: 'Lembrete: Apuração de impostos', destinatario: 'empresaemail@gmail.com', templates: 'Reenvio 1 - Apuração', status: 'enviado', enviado_em: '20/06/2025, 20:18:05'},
      { id: 9, remetente: 'smtp@mkt.odoscontabilidade.com.br', assunto: 'Lembrete: Apuração de impostos', destinatario: 'empresaemail@gmail.com', templates: 'Reenvio 1 - Apuração', status: 'enviado', enviado_em: '20/06/2025, 20:18:05'},
      { id: 10, remetente: 'smtp@mkt.odoscontabilidade.com.br', assunto: 'Lembrete: Apuração de impostos', destinatario: 'empresaemail@gmail.com', templates: 'Reenvio 1 - Apuração', status: 'enviado', enviado_em: '20/06/2025, 20:18:05'},
      { id: 12, remetente: 'smtp@mkt.odoscontabilidade.com.br', assunto: 'Lembrete: Apuração de impostos', destinatario: 'empresaemail@gmail.com', templates: 'Reenvio 1 - Apuração', status: 'enviado', enviado_em: '20/06/2025, 20:18:05'},
      { id: 13, remetente: 'smtp@mkt.odoscontabilidade.com.br', assunto: 'Lembrete: Apuração de impostos', destinatario: 'empresaemail@gmail.com', templates: 'Reenvio 1 - Apuração', status: 'enviado', enviado_em: '20/06/2025, 20:18:05'},
      { id: 14, remetente: 'smtp@mkt.odoscontabilidade.com.br', assunto: 'Lembrete: Apuração de impostos', destinatario: 'empresaemail@gmail.com', templates: 'Reenvio 1 - Apuração', status: 'enviado', enviado_em: '20/06/2025, 20:18:05'},
      { id: 15, remetente: 'smtp@mkt.odoscontabilidade.com.br', assunto: 'Lembrete: Apuração de impostos', destinatario: 'empresaemail@gmail.com', templates: 'Reenvio 1 - Apuração', status: 'enviado', enviado_em: '20/06/2025, 20:18:05'},
      { id: 16, remetente: 'smtp@mkt.odoscontabilidade.com.br', assunto: 'Lembrete: Apuração de impostos', destinatario: 'empresaemail@gmail.com', templates: 'Reenvio 1 - Apuração', status: 'enviado', enviado_em: '20/06/2025, 20:18:05'},
      { id: 17, remetente: 'smtp@mkt.odoscontabilidade.com.br', assunto: 'Lembrete: Apuração de impostos', destinatario: 'empresaemail@gmail.com', templates: 'Reenvio 1 - Apuração', status: 'enviado', enviado_em: '20/06/2025, 20:18:05'},
    ]);

    useEffect(() => {
        setCount(dataSents.length);
    }, [dataSents, setCount]);

    const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  const totalPages = Math.ceil(dataSents.length / itemsPerPage);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const indexStart = (currentPage - 1) * itemsPerPage;
  const indexEnd = indexStart + itemsPerPage;
  const paginatedData = dataSents.slice(indexStart, indexEnd);

  return (
    <div>
      {paginatedData.length > 0 ? (
      <>
        <Table colunas={columns} dados={paginatedData} />

        {dataSents.length > itemsPerPage && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            showPageNumbers={true}
            maxPageNumbers={8}
          />
        )}
      </>
    ) : (
      <div className="text-center text-gray-500 py-8">
        Nenhum e-mail foi enviado.
      </div>
    )}
    </div>
  );
};

export default Sent